import { render, staticRenderFns } from "./TSZ_Comparativas.vue?vue&type=template&id=7a4cd77b&"
import script from "./TSZ_Comparativas.vue?vue&type=script&lang=js&"
export * from "./TSZ_Comparativas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports